"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") {
		for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: () => from[key],
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var filterRootHTML_exports = {};
__export(filterRootHTML_exports, { filterRootHTML: () => filterRootHTML });
module.exports = __toCommonJS(filterRootHTML_exports);
var import_react = require("react");
function filterRootHTML(el) {
	var htmlProps;
	var bodyProps;
	var head;
	function traverse(element) {
		if (!element || typeof element !== "object") return element;
		if (Array.isArray(element)) return element.map(traverse);
		var reactElement = element;
		var { type, props } = reactElement;
		if (type === "html") {
			if (props && typeof props === "object" && "children" in props) {
				var { children: children2, ...restProps } = props;
				htmlProps = restProps;
				return traverse(children2);
			}
			return null;
		}
		if (type === "head") {
			head = reactElement;
			return null;
		}
		if (type === "body") {
			if (props && typeof props === "object" && "children" in props) {
				var { children: children1, ...restProps1 } = props;
				bodyProps = restProps1;
				return traverse(children1);
			}
			return null;
		}
		if ((0, import_react.isValidElement)(element) && typeof element.type === "string" && element.type.toLowerCase() === element.type) {
			if (element.props && typeof element.props === "object" && "children" in element.props) return traverse(element.props.children);
			return null;
		}
		return element;
	}
	return {
		children: traverse(el) || el,
		htmlProps,
		bodyProps,
		head
	};
}
//# sourceMappingURL=filterRootHTML.js.map
